import { c as _c } from "react/compiler-runtime";
import { Button } from '@sbt-web/ui';
export const PrivateUserContact = t0 => {
  const $ = _c(2);
  const {
    className
  } = t0;
  const handleClick = _temp;
  const t1 = className ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = <Button classes={[t1]} design="outline" onClick={handleClick}>Contatta</Button>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
function _temp() {
  window.dispatchEvent(new CustomEvent("subito:AdView:BtnAuthorReply"));
}